export const shadows = {
  small: "0px 3px 10px rgba(0, 0, 0, 0.06)",
  base: "0px 5px 15px rgba(0, 0, 0, 0.1);",
  large: "0px -5px 15px rgba(0, 0, 0, 0.1);",
};
